import type { ReactNode } from 'react';
import { KyckLogo } from '../../../components/branding/KyckLogo';

// Phase 6B Phase D — the minimal, mobile-first chrome for the public survey
// page. No AppShell / sidebar (rendered outside SignedInGuard). Kyck wordmark
// header + a content column capped at ~600px so it reads well on phone + desktop.
export function PublicShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-[600px] items-center px-4 py-3">
          <KyckLogo variant="dark-text" size={26} />
        </div>
      </header>
      <main className="mx-auto max-w-[600px] px-4 py-6 sm:py-10">{children}</main>
    </div>
  );
}

// Centered terminal-state message (cancelled / closed / expired / not-found).
export function TerminalMessage({
  icon,
  title,
  body,
}: {
  icon?: ReactNode;
  title: string;
  body?: ReactNode;
}) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white px-6 py-12 text-center shadow-sm">
      {icon && <div className="mb-3 text-3xl">{icon}</div>}
      <h1 className="text-lg font-semibold text-slate-800">{title}</h1>
      {body && <div className="mx-auto mt-2 max-w-sm text-sm text-slate-500">{body}</div>}
    </div>
  );
}
